import { render, staticRenderFns } from "./LabelText.vue?vue&type=template&id=4dc61795&scoped=true"
import script from "./LabelText.vue?vue&type=script&lang=js"
export * from "./LabelText.vue?vue&type=script&lang=js"
import style0 from "./LabelText.vue?vue&type=style&index=0&id=4dc61795&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc61795",
  null
  
)

export default component.exports